module.exports = __webpack_public_path__ + "img/contract@2x.88ad0e8b.png";